"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialProductDisplayModal = void 0;
const react_1 = require("react");
const constants_1 = require("root/src/shared/rewards/constants");
const productResolver_service_1 = require("root/src/shared/rewards/services/productResolver.service");
const getBountyName_1 = __importDefault(require("root/src/shared/util/getBountyName"));
const useClipboard_1 = require("root/src/client/web/hooks/useClipboard");
const Link_1 = __importDefault(require("root/src/client/web/base/Link"));
const PasswordInput_1 = require("root/src/client/v2/auth/components/PasswordInput");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const ic_clipboard_2_svg_1 = __importDefault(require("root/src/client/public/icons/ic-clipboard-2.svg"));
const CopyToClipboardBase_1 = require("root/src/client/web/base/CopyToClipboardBase");
const protocolUtil_1 = require("root/src/shared/util/protocolUtil");
const modal_context_1 = require("root/src/client/v2/common/contexts/modal.context");
const ModalLayout_1 = require("root/src/client/v2/common/layouts/ModalLayout");
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const ButtonNew_1 = require("root/src/client/v2/common/components/form/ButtonNew");
exports.InitialProductDisplayModal = (0, react_1.memo)((props) => {
    const { dropEvent, product, dare } = props;
    const [isAgreed, setIsAgreed] = (0, react_1.useState)(false);
    const shortUrl = (0, protocolUtil_1.addHttpsProtocol)(props.shortUrl);
    const modal = (0, modal_context_1.useModal)();
    return (<ModalLayout_1.ModalLayout className="sm:min-w-[600px]">
			<form onSubmit={(event) => {
            event.preventDefault();
            modal.hide();
        }}>
				<div className="flex flex-col justify-center items-center gap-4">
					<Heading />
					<Dare dare={dare}/>
					<Spacer />
					<Product product={product} shortUrl={shortUrl} isGameFree={dropEvent.isGameFree}/>
					<ShortUrl shortUrl={shortUrl}/>
					<FormControlLabel_1.default control={(<Checkbox_1.default checked={isAgreed} onChange={(_, isChecked) => {
                setIsAgreed(isChecked);
            }}/>)} label={(<span className="text-sm">
								I agree to post this link with my content
							</span>)}/>
					<ButtonNew_1.ButtonNew type="submit" disabled={!isAgreed} className="font-bold uppercase text-center">
						Continue
					</ButtonNew_1.ButtonNew>
				</div>
			</form>
		</ModalLayout_1.ModalLayout>);
});
const Dare = (0, react_1.memo)((props) => {
    const { dare } = props;
    const game = dare.games[0];
    const dareProductRegion = (0, react_1.useMemo)(() => {
        if (dare.product.type === constants_1.RewardType.KEY) {
            return new productResolver_service_1.KeyProductMnemonicIdResolver(dare.product.id).getReadableRegion();
        }
        return 'Worldwide';
    }, [dare]);
    return (<div className="flex flex-col justify-center items-center gap-4">
			<img src={game.image} alt={game.label} className="w-36 h-48"/>
			<div className="flex justify-between gap-12">
				<div className="flex gap-1 text-text-2xs">
					<span className="text-light-5 uppercase text-2xs">Type:</span>
					<span className="uppercase text-2xs">{dare.type}</span>
				</div>
				<div className="flex gap-1">
					<span className="text-light-5 uppercase text-2xs">Level:</span>
					<span className="uppercase text-2xs">{dare.level}</span>
				</div>
			</div>
			<div className="flex flex-col gap-1 justify-center items-center">
				<span className="text-light-5 uppercase text-2xs text-center">
					Loot for your fans:
				</span>
				<span className="text-light-5 text-sm text-center">
					{(0, getBountyName_1.default)({
            name: dare.product.name,
            type: dare.product.type,
            amount: dare.amount,
        }, false)}
				</span>
			</div>
			<div className="flex flex-col justify-center items-center gap-2">
				<span className="bg-dark-1 text-light-3 rounded px-6 py-1 text-xs">
					{dareProductRegion}
				</span>
				<span className="text-sm font-medium">{dare.title}</span>
			</div>
		</div>);
});
const Spacer = (0, react_1.memo)(() => {
    return <div className="flex w-1/3 h-[1px] bg-white flex-initial"/>;
});
const Heading = (0, react_1.memo)(() => {
    return (<div className="flex flex-col justify-center items-center gap-1">
			<h1 className="font-bold text-2xl text-center">Ready player one?</h1>
			<span className="text-center text-light-4 font-medium text-2xs">
				Your key is below. Copy the key to your clipboard and head
				<br />
				on over to Steam and complete the Dare!
			</span>
		</div>);
});
const Product = (0, react_1.memo)((props) => {
    const { product, shortUrl, isGameFree } = props;
    const { writeText } = (0, useClipboard_1.useClipboard)();
    if (!product) {
        return (<div className="flex flex-col justify-center items-center gap-2">
				<span className="text-center">No initial key for this drop</span>
				<Link_1.default href={shortUrl}>
					{isGameFree ? 'Free to play' : 'Get the game here to dare'}
				</Link_1.default>
			</div>);
    }
    return (<div className="flex w-full flex-col justify-center items-center gap-2 relative">
			<PasswordInput_1.PasswordInput label="Your key" value={product} aria-readonly="true" InputProps={{
            readOnly: true,
        }}/>
			<button type="button" className="absolute -right-14 bg-light-3 rounded px-3 py-1.5 border-2 border-light-5" onClick={() => __awaiter(void 0, void 0, void 0, function* () {
            yield writeText(product);
            react_hot_toast_1.default.success('Key copied to clipboard');
        })}>
				<img src={ic_clipboard_2_svg_1.default.src} alt="Clipboard"/>
			</button>
		</div>);
});
const ShortUrl = (0, react_1.memo)((props) => {
    const { shortUrl } = props;
    return (<CopyToClipboardBase_1.CopyToClipboardBase onCopied={() => {
            react_hot_toast_1.default.success('Link copied to clipboard');
        }} text={shortUrl}>
			<div className="flex flex-col gap-2 justify-center items-center">
				<img className="w-6 h-6" src={ic_clipboard_2_svg_1.default.src} alt="Clipboard"/>
				<p className="text-teal uppercase text-sm text-center">Copy game link to clipboard</p>
			</div>
		</CopyToClipboardBase_1.CopyToClipboardBase>);
});
